"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  shell: {
    componentTitle: 'Fulfillment Configurations',
    incompletePropsMessage: 'Not enough information provided, please fill out all required test order fields.'
  },
  selectedConfigurationDisplay: {
    selectedConfigurationLabel: 'SELECTED CONFIGURATION:',
    noSelectedConfigurationLabel: 'Select a configuration:',
    clearButton: 'Clear selection'
  },
  fulfillmentConfigurationList: {
    actions: {
      error500: 'Something went wrong in retrieving the list of Fulfillment Configurations. You can hit retry to see if it gets resolved.',
      permissionsError: 'Looks like you do not have permission to view these Fulfillment Configurations.' + ' Please contact Platform Support to obtain access.',
      unknownError: 'An unknown error occurred. Please try again.'
    },
    table: {
      nameHeader: 'Fulfillment Configuration name'
    },
    selectVersionButton: 'Select version'
  },
  fulfillmentConfigurationErrorPage: {
    noAvailableFulfillmentConfigurations: {
      titleText: 'There are no available Fulfillment Configurations for this product.',
      productAssociationsSuggestion: 'Check your ',
      productAssociationsLink: 'Product Associations',
      fulfillmentConfigurationsSuggestion: 'Create a new ',
      fulfillmentConfigurationsLink: 'Fulfillment Configuration',
      emailSuggestion: 'Need more support? Contact ',
      emailLink: 'platformsupport@cimpress.com',
      tryAgainText: 'Made some changes? Click here to try again.'
    },
    error: {
      errorTitle: 'There was an error loading the Fulfillment Configurations'
    },
    reloadButtonText: 'Reload'
  },
  search: {
    searchFieldLabel: 'Search configurations'
  },
  versionsList: {
    table: {
      moreInfoButton: 'More info',
      rowContentsHeader: 'Version',
      noVersionsText: 'No versions found'
    },
    backButton: 'Back'
  }
};
exports["default"] = _default;